import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { loadEvent } from '@common/redux/slices/event.slice';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { IframeSingleEvent } from '@kursk/components/pages/IframeSingleEvent/IframeSingleEvent';

export default function Event({ notFound, event }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return (
    <IframeSingleEvent event={event}/>
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params }) => {
  const { id } = params;
  await store.dispatch<any>(loadEvent({ _id: id }));
  const { event } = store.getState().eventSlice;

  if (event?._id) {
    return {
      props: { event }
    };
  } else {
    return {
      props: { notFound: true }
    };
  }
});
